import { useQuery } from '@tanstack/react-query';
import { api } from '../../lib/api';
import type { CurrentUser } from '../../types/user';

export function useCurrentUserQuery(enabled: boolean) {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      const res = await api<{ user: CurrentUser }>('/api/me');
      return res.user;
    },
    enabled,
    staleTime: 5 * 60_000,
    retry: 1,
  });
}
